(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197,1674],{

/***/ 379305:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(256911);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 256911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(117321);
/* harmony import */ var _containers_404Page_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(692687);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(225617);
/* harmony import */ var src_utils_isWebsiteInternallyRouted__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(119997);






var ErrorPage = function() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var isCustomDomain = (0,src_utils_isWebsiteInternallyRouted__WEBPACK_IMPORTED_MODULE_4__/* .isWebsiteInternallyRouted */ .G)(window.location.host);
        var domainName = "".concat(isCustomDomain ? "d-" : "").concat(window.location.host.replace("www.", ""));
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_5__/* .fetchStoreInfoBySubDomain */ .rf)(domainName));
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_404Page_index__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ErrorPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8388,1562,1033,3978,2687,9774,2888,179], function() { return __webpack_exec__(379305); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);